import React from 'react';
import TestimonialData from "../../data/testimonial/TestimonialData.json";

const allData = TestimonialData;

const TestimonialItem = ({ colSize, itemShow }) => {
    return (
        <>
            <style>
                {`
                    .testimonial-grid {
                        padding: 20px;
                        border-radius: 10px;
                        box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
                        background: #fff;
                        text-align: center;
                    }
                    
                    .social-media img {
                        max-width: 80px; /* Adjust logo size */
                        height: auto;
                    }

                    .author-info {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        gap: 15px;
                        margin-top: 15px;
                    }

                    .thumb img {
                        width: 60px;
                        height: 60px;
                        object-fit: cover;
                        border-radius: 50%;
                        border: 3px solid #eee;
                    }

                    .content .name {
                        font-weight: bold;
                        font-size: 1rem;
                    }

                    .content .designation {
                        color: #777;
                        font-size: 0.9rem;
                    }
                `}
            </style>
            {allData.slice(0, itemShow).map((data, index) => (
                <div className={`${colSize}`} key={index}>
                    <div className="testimonial-grid">
                        <span className="social-media">
                            <img src={process.env.PUBLIC_URL + data.from} alt="Review Source" />
                        </span>
                        <p>{data.description}</p>
                        <div className="author-info">
                            <div className="thumb">
                                <img
                                    src={process.env.PUBLIC_URL + data.authorimg}
                                    alt="Author Profile"
                                />
                            </div>
                            <div className="content">
                                <span className="name">{data.authorname}</span>
                                <span className="designation">{data.authordesig}</span>
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </>
    );
};

export default TestimonialItem;
